module.exports = __webpack_public_path__ + "static/media/unric-logo-1.1797c194.png";